/**
 * This file provides a dedicated import for html2canvas
 * to resolve potential bundling issues with Vite
 */

// We'll use a promise-based approach for better compatibility
let html2canvasPromise = null;

// Function to load html2canvas
const loadHtml2Canvas = async () => {
  if (html2canvasPromise) {
    return html2canvasPromise;
  }

  html2canvasPromise = new Promise(async (resolve) => {
    try {
      // Modern dynamic import approach (works better with bundlers like Vite)
      const module = await import('html2canvas');
      const html2canvasFunc = module.default || module;
      console.log('Successfully loaded html2canvas');
      resolve(html2canvasFunc);
    } catch (err) {
      console.error('Failed to import html2canvas:', err);
      // Fallback that returns a function that logs the error
      resolve(() => {
        console.error('html2canvas is not available');
        return Promise.reject(new Error('html2canvas could not be loaded'));
      });
    }
  });

  return html2canvasPromise;
};

// Export a function that ensures html2canvas is loaded before use
export default async function html2canvas(element, options) {
  const html2canvasFunc = await loadHtml2Canvas();
  return html2canvasFunc(element, options);
} 